import {NinchatErrorType} from 'api/types/errors'

type AssignOldestTranscriptError = {
    error_reason?: string
    error_type?: string
}

type Translate = (key: string) => string

export const getAssignOldestTranscriptErrorMessage = (
    error: AssignOldestTranscriptError,
    t: Translate,
): string => {
    switch (error?.error_type) {
        case NinchatErrorType.NinchatAudienceNotFoundError:
            return t('No assignable tickets right now')
        case NinchatErrorType.NinchatQueueNotFoundError:
            return t('Queue not found')
        case NinchatErrorType.NinchatPermissionDeniedError:
            return error?.error_reason === 'Transcript is already assigned'
                ? t('Ticket is already assigned')
                : t('Permission denied')
        default:
            return t('Error assigning ticket')
    }
}
